import isMiniProgramUserAgent from "@Utils/isMiniProgramUserAgent";

// const getUtmSource = (): string | undefined => {
//   if (typeof window !== "undefined" && window.__INITIAL_STATE__) {
//     const initialState: any = window.__INITIAL_STATE__;
//     return initialState.appData.UtmDetails?.utm_source;
//   }
//   return "";
// };
export const getUtmReferrer = () => {
  if (typeof window !== "undefined" && window.__INITIAL_STATE__) {
    const referrer: any = document?.referrer || "";
    return referrer;
  }
  return "";
};
export const getUtmSourceFromCookie = (): string | null => {
  if (typeof window === "undefined" || !window.getCookie) return null;

  const { getCookie } = window;
  if (!getCookie) return null;

  const utmParamString = getCookie("initial_utm_params") || "";
  if (!utmParamString.trim()) return null;

  // Split by "|" and find the utm_source pair
  const utmSourcePair = utmParamString
    .split("|")
    .map((pair: any) => pair.trim())
    .find((pair: any) => pair.startsWith("utm_source="));

  if (!utmSourcePair) return null;

  const [, value] = utmSourcePair.split("=");
  return value && value.trim() !== "" ? decodeURIComponent(value) : null;
};

const getWeComUrlBasedOnSource = () => {
  const utmSourceCookie = getUtmSourceFromCookie();
  const utmReferrer = getUtmReferrer();
  let URLDweb = `https://work.weixin.qq.com/ca/cawcdee3d56bdeba92`; // organic for dweb
  let URLMweb = `https://work.weixin.qq.com/ca/cawcde6f859c6f5103`; // organic for mweb

  if (isMiniProgramUserAgent()) {
    URLDweb = `https://work.weixin.qq.com/ca/cawcde1f48f8bf8032`;
    URLMweb = `https://work.weixin.qq.com/ca/cawcde1f48f8bf8032`;
  }
  if (utmSourceCookie?.includes("baidu_ads")) {
    URLDweb = `https://work.weixin.qq.com/ca/cawcdebba13279bf90`;
    URLMweb = `https://work.weixin.qq.com/ca/cawcdebb14ff6d0bda`;
  }
  if (utmReferrer.includes("baidu") && !utmSourceCookie) {
    URLDweb = `https://work.weixin.qq.com/ca/cawcdedc677efc2fc5`;
    URLMweb = `https://work.weixin.qq.com/ca/cawcded394e2c2785f`;
  }
  if (utmSourceCookie === "google_ads_cn" || utmSourceCookie === "google_adwords") {
    URLDweb = `https://work.weixin.qq.com/ca/cawcdefb6dd65fde7c`;
    URLMweb = `https://work.weixin.qq.com/ca/cawcde321f0c383c69`;
  }
  if (utmSourceCookie?.includes("wechat") || utmSourceCookie?.includes("weixin")) {
    URLDweb = `https://work.weixin.qq.com/ca/cawcde6c97ccd0083e`;
    URLMweb = `https://work.weixin.qq.com/ca/cawcde6c97ccd0083e`;
  }

  return { URLDweb, URLMweb };
};

export default getWeComUrlBasedOnSource;

const HK_WEIXIN = getWeComUrlBasedOnSource();
export const HK_WEIXIN_DWEB =
  HK_WEIXIN.URLDweb || "https://work.weixin.qq.com/ca/cawcdee3d56bdeba92";
export const HK_WEIXIN_MWEB =
  HK_WEIXIN.URLMweb || "https://work.weixin.qq.com/ca/cawcde6f859c6f5103";
